/*=========================================================================================
  File Name: moduleSpaceGetters.js
  Description: Space Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  filteredNoticeBoard: state => state.noticeBoards.filter((noticeBoard) => {
    if(state.noticeBoardSearchQuery.id){      
      return ((noticeBoard.user_id == state.noticeBoardSearchQuery.id) && (noticeBoard.answer.toLowerCase().includes(state.noticeBoardSearchQuery.keywoard.toLowerCase()) || noticeBoard.question.toLowerCase().includes(state.noticeBoardSearchQuery.keywoard.toLowerCase())))
    }
    if(state.noticeBoardSearchQuery.state == 0){
      return (noticeBoard.answer.toLowerCase().includes(state.noticeBoardSearchQuery.keywoard.toLowerCase()) || noticeBoard.question.toLowerCase().includes(state.noticeBoardSearchQuery.keywoard.toLowerCase()))
    } else if(state.noticeBoardSearchQuery.state == 1){ // 답변 있는거
      return ((noticeBoard.answer) && (noticeBoard.answer.toLowerCase().includes(state.noticeBoardSearchQuery.keywoard.toLowerCase()) || noticeBoard.question.toLowerCase().includes(state.noticeBoardSearchQuery.keywoard.toLowerCase())))
    } else {//답변 없는거
      return ((!noticeBoard.answer) && (noticeBoard.answer.toLowerCase().includes(state.noticeBoardSearchQuery.keywoard.toLowerCase()) || noticeBoard.question.toLowerCase().includes(state.noticeBoardSearchQuery.keywoard.toLowerCase())))
    }
  }),
}
